function responseHeader(error: any, name: string): string {
  const headers = error?.response?.headers
  if (!headers) return ''
  if (typeof headers.get === 'function') return String(headers.get(name) || '')
  return String(headers[name.toLowerCase()] || headers[name] || '')
}

export function uploadErrorMessage(error: any, fallback: string): string {
  if (error?.response?.status !== 413) return error?.response?.data?.error || error?.message || fallback

  const backend = responseHeader(error, 'x-nhex-backend')
  const frontendProxy = responseHeader(error, 'x-nhex-proxy')
  const applicationMessage = error?.response?.data?.error
  if (backend) {
    if (typeof applicationMessage === 'string' && applicationMessage.trim()) return applicationMessage
    return 'The NHEX backend rejected this upload because an application limit was exceeded.'
  }
  if (!backend && !frontendProxy) {
    return 'Upload was rejected by the external reverse proxy before it reached NHEX. Raise client_max_body_size and request-body limits on the public proxy.'
  }
  return 'Upload was rejected by the frontend Nginx before it reached the backend. Rebuild its image and verify client_max_body_size 2g.'
}
